/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Previewerror3Inputs */

const en_coinvestments_draftemail_previewerror3 = /** @type {(inputs: Coinvestments_Draftemail_Previewerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't generate the preview. You can still send the email.`)
};

/**
* | output |
* | --- |
* | "We couldn't generate the preview. You can still send the email." |
*
* @param {Coinvestments_Draftemail_Previewerror3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_previewerror3 = /** @type {((inputs?: Coinvestments_Draftemail_Previewerror3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Previewerror3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_previewerror3(inputs)
});
export { coinvestments_draftemail_previewerror3 as "coInvestments_draftEmail_previewError" }